module.exports = __webpack_public_path__ + "static/media/list-marker.f24426cd.svg";